import { FC, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import QAAgentEntity from "../../../../domain/entities/qa_agent.entity";
import { useForm } from "react-hook-form";
import QAQuestionEntity from "../../../../domain/entities/qa_question.entity";
import LocalizationContextType from "../../../../domain/providers/localization/LocalizationContextType";
import ModalsContextType from "../../../../domain/providers/modal/ModalsContextType";
import LocalizationContext from "../../../providers/localization/LocalizationContext";
import ModalsContext from "../../../providers/modal/ModalsContext";
import { isLeft } from "fp-ts/lib/Either";
import di from "../../../../dependency_injection";
import GetAgentByIdUseCase, { GetAgentByIdUseCaseName } from "../../../../domain/use_cases/qa/get_agent_by_id.use_case";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import LayoutComponent from "../../../layouts/layoutComponent/layout.component";
import NotFoundComponent from "../../../components/notFound/not_found.component";
import LoadingComponent from "../../../components/LoadingComponent/loading.component";
import CategoriesEditionComponent from "./widgets/categories_edition/categories_edition.component";
import ButtonComponent from "../../../components/button/button.component";
import UpdateAgentUseCase, { UpdateAgentUseCaseName } from "../../../../domain/use_cases/qa/update_agent.use_case";
import CreateAgentComponent from "../create/form/create_agent.component";
import RestApi from "../../../../data/settings/RestApi";
import UploadFilesToAgentComponent from "./upload_files_to_agent.component";

const EditAgentPage: FC<{}> = () => {
    const { id } = useParams<{ id: string }>();

    const { i18n } = useContext(LocalizationContext) as LocalizationContextType;
    const { addToast, closeModalCustom, openModalCustom } = useContext(ModalsContext) as ModalsContextType;

    const [agent, setAgent] = useState<QAAgentEntity | null | undefined>(undefined);
    const [flexibility, setFlexibility] = useState<number | null>(null);

    const _searchAgent = async () => {
        if (id == undefined) return setAgent(null);
        const response = await di.get<GetAgentByIdUseCase>(GetAgentByIdUseCaseName).call(id);
        if (isLeft(response)) return setAgent(null);
        setAgent(response.right);
    }

    const _handleUpdateAgent = () => {
        const _updateAgent = async (formData: FormData) => {
            const response = await di.get<UpdateAgentUseCase>(UpdateAgentUseCaseName).call(formData);

            if (isLeft(response)) {
                return addToast(
                    i18n(response.left.code ?? KeyWordLocalization.EditAgentPageErrorUpdatingAiAgent),
                    'error',
                    undefined
                );
            }

            closeModalCustom();
            addToast(i18n(KeyWordLocalization.EditAgentPageUpdatedAiAgent), 'success', undefined);

            // 🔄 Recarga el agente desde el backend para asegurar que vengan los archivos actualizados
            await _searchAgent();
        };


        openModalCustom(
            "lg",
            i18n(KeyWordLocalization.EditAgentPageUpdateAiAgent),
            <div style={{ maxHeight: "60vh", overflowY: "auto", overflowX: "hidden", paddingRight: "0.5rem" }}>
                <CreateAgentComponent onUpdated={_updateAgent} agent={agent!} onRefresh={_searchAgent} />
            </div>,
            { hideOnTap: false }
        );


    };

    useEffect(() => {
        _searchAgent();
    }, [id]);

    return <div className="detailed_agent_page">
        <LayoutComponent title={i18n(KeyWordLocalization.EditAgentPageTitle)}>
            {agent === undefined && <LoadingComponent />}
            {agent === null && <NotFoundComponent />}
            {agent && <>
                <div className="container py-3">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1 text_ellipsis">
                                    <h1 style={{ fontSize: '1.5em' }}>
                                        {i18n(KeyWordLocalization.EditAgentPageTitle)}: {agent.name}
                                    </h1>
                                </div>

                                <div className="d-flex">
                                    <ButtonComponent
                                        design="primaryOutline"
                                        icon={<span className="material-symbols-outlined">edit</span>}
                                        onClick={_handleUpdateAgent}
                                        text={i18n(KeyWordLocalization.edit)}
                                    />
                                </div>
                            </div>

                            <span>{i18n(KeyWordLocalization.EditAgentPageTarget)}: {agent.target}</span><br />
                            <span>{i18n(KeyWordLocalization.EditAgentPageFlexibility)}: {agent.flexibility}</span>
                            <p>{agent.description}</p>
                            <span
                                className="badge mb-3 px-3 py-1 rounded-pill text-dark"
                                style={{
                                    fontSize: '0.9em',
                                    backgroundColor:
                                        agent.is_assistant
                                            ? 'var(--color-yellow)'
                                            : 'var(--bs-secondary)',
                                }}
                            >
                                {agent.is_assistant ? i18n(KeyWordLocalization.CreateAgentPageAdvancedAgent)
                                    : i18n(KeyWordLocalization.CreateAgentPageBasicAgent)}
                            </span>


                            {agent.is_assistant && agent.files.length > 0 ? (
                                <div className="mt-2">
                                    <strong>Context Files:</strong>
                                    <ul className="mb-0">
                                        {agent.files.map((file, index) => (
                                            <li key={index}>{file.filename}</li>
                                        ))}
                                    </ul>
                                </div>
                            ) : null}


                            {agent.assistant_id && agent.vector_store_id && (
                                <UploadFilesToAgentComponent
                                    agentId={agent.id}
                                    assistantId={agent.assistant_id}
                                    vectorStoreId={agent.vector_store_id}
                                    onUploaded={_searchAgent}
                                />
                            )}


                            {/* <ButtonComponent onClick={_handleEdit} icon={
                            <span className="material-symbols-outlined">edit</span>
                        } text={KeyWordLocalization.edit} /> */}
                        </div>
                    </div>

                    <div className="card elvated my-3">
                        <CategoriesEditionComponent agent={agent} setAgent={setAgent} />
                    </div>

                </div>
            </>}
        </LayoutComponent>
    </div >

}

export default EditAgentPage;